import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useForm } from "react-hook-form";
import {
  errorToastify,
  successToastify,
} from "../../../Components/Common/Toaster";
import { updateProductTypeWithOutHUID } from "../../../helpers/urlConfig/apiFunctions";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

function ProductTypeWithOutHUIDEdit({
  modal_list,
  setmodal_list,
  tog_list,
  fetchData,
  currentProductType,
}) {
  const { register, handleSubmit } = useForm({
    defaultValues: currentProductType,
  });

  const onSubmit = async (data) => {
    try {
      if (
        (parseInt(data.stock) == 0 && parseInt(data.gram) > 0) ||
        (parseInt(data.stock) > 0 && parseInt(data.gram) == 0)
      ) {
        return errorToastify(
          "You can't update data to zero stocks or zero gram"
        );
      } else {
        data.updated_by = getSessionData("user_id");
        const response = await updateProductTypeWithOutHUID(data);
        if (response.statusCode === 200) {
          successToastify("Product Type updated successfully!");
          fetchData();
          setmodal_list(false);
        } else {
          errorResponseHandler(response);
        }
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <Modal
      isOpen={modal_list}
      toggle={() => {
        tog_list();
      }}
      centered
    >
      <ModalHeader
        className="bg-light p-3"
        toggle={() => {
          tog_list();
        }}
      >
        {" "}
        Edit Product Type{" "}
      </ModalHeader>
      <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
        <ModalBody>
          <div className="mb-3">
            <label htmlFor="customername-field" className="form-label">
              Product Type Name
            </label>
            <input
              type="text"
              id="customername-field"
              className="form-control"
              placeholder="Enter Product Type Name"
              required
              {...register("product_type_name", {
                required: "Product Type Name is required",
              })}
              disabled
            />
          </div>

          <div className="mb-3">
            <label htmlFor="modelname-field" className="form-label">
              Model Name
            </label>
            <input
              type="text"
              id="modelname-field"
              className="form-control"
              placeholder="Enter Model Name"
              required
              {...register("model_name", {
                required: "Model Name is required",
              })}
              disabled
            />
          </div>

          <div className="mb-3">
            <label htmlFor="customername-field" className="form-label">
              Grams
            </label>
            <input
              type="text"
              id="customername-field"
              className="form-control"
              placeholder="Enter Gram"
              required
              {...register("gram", {
                required: "Grams is required",
              })}
            />
          </div>

          {/* <div className="mb-3">
            <label htmlFor="gender" className="form-label">
              Gender
            </label>
            <select
              id="gender"
              className="form-control"
              {...register("gender")}
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div> */}

          {/* <div className="mb-3">
            <label htmlFor="customername-field" className="form-label">
              Age
            </label>
            <input
              type="text"
              id="customername-field"
              className="form-control"
              placeholder="Enter Age"
              {...register("age")}
            />
          </div> */}

          <div className="mb-3">
            <label htmlFor="customername-field" className="form-label">
              Stock
            </label>
            <input
              type="text"
              id="customername-field"
              className="form-control"
              placeholder="Enter Stock"
              required
              {...register("stock", {
                required: "Stock is required",
              })}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => setmodal_list(false)}
            >
              Close
            </button>
            <button type="submit" className="btn btn-success" id="add-btn">
              Edit Product Type
            </button>
            {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
}

export default ProductTypeWithOutHUIDEdit;
